import { BookOpen, Contrast, Moon, Palette, type LucideIcon } from 'lucide-react';
import { useTheme, type Theme } from '../../contexts/ThemeContext';

const CHOICES: { id: Theme; label: string; title: string; Icon: LucideIcon }[] = [
  { id: 'light-mono', label: 'Tema claro monocromo', title: 'Claro · Mono', Icon: Contrast },
  { id: 'light', label: 'Tema claro a color', title: 'Claro · Color', Icon: Palette },
  { id: 'sepia', label: 'Tema sepia', title: 'Sepia', Icon: BookOpen },
  { id: 'dark', label: 'Tema oscuro', title: 'Oscuro', Icon: Moon },
];

/** Radiogroup with a roving tabindex: one tab stop, arrows move inside the group. */
export function ThemeSwitch() {
  const { theme, setTheme } = useTheme();

  const move = (delta: number) => {
    const index = CHOICES.findIndex((choice) => choice.id === theme);
    const next = CHOICES[(index + delta + CHOICES.length) % CHOICES.length];
    setTheme(next.id);
    return next.id;
  };

  return (
    <div
      className="xd-theme-switch"
      role="radiogroup"
      aria-label="Tema de color"
      onKeyDown={(event) => {
        const delta =
          event.key === 'ArrowRight' || event.key === 'ArrowDown'
            ? 1
            : event.key === 'ArrowLeft' || event.key === 'ArrowUp'
              ? -1
              : 0;
        if (!delta) return;
        event.preventDefault();
        const next = move(delta);
        event.currentTarget
          .querySelector<HTMLButtonElement>(`[data-xd-theme-choice="${next}"]`)
          ?.focus();
      }}
    >
      {CHOICES.map((choice) => {
        const selected = theme === choice.id;
        return (
          <button
            key={choice.id}
            type="button"
            role="radio"
            data-xd-theme-choice={choice.id}
            aria-checked={selected}
            aria-label={choice.label}
            title={choice.title}
            tabIndex={selected ? 0 : -1}
            onClick={() => setTheme(choice.id)}
          >
            <choice.Icon className="h-4 w-4" aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
